import { IntlShape } from 'react-intl'

import { Attestations, ConnectedServiceAttestation, FormMetadata } from '../../models'
import { extendMetadata } from '../assignments/utils'

export const extendMetadataAttestations = ({
  attestationContents,
  connectedServiceAttestation,
  errorMessage,
  metadata,
  intl,
  checkboxProps,
  baseInputStyle,
}: {
  attestationContents: Attestations | null
  connectedServiceAttestation?: ConnectedServiceAttestation
  errorMessage: {
    defaultMessage: string
    description: string
  }
  metadata: FormMetadata
  intl: IntlShape
  checkboxProps?: Dict
  baseInputStyle?: React.CSSProperties
}) => {
  let extendedMetadata = metadata
  if (attestationContents) {
    extendedMetadata = attestationContents.reduce((combinedSchema, attestation, index) => {
      const fieldName = `attestation-${index}`
      combinedSchema = extendMetadata(combinedSchema, {
        schema: {
          properties: {
            [`${fieldName}`]: {
              name: fieldName,
              title: attestation.attestationText,
              type: 'boolean',
              validation: {
                isBooleanTrue: true,
              },
              customErrorMessage: intl.formatMessage(errorMessage),
              ...(checkboxProps && { widgetProps: checkboxProps }),
            },
          },
        },
        uiSchema: {
          'ui:order': [fieldName],
          [fieldName]: {
            'ui:widget': 'checkbox',
            'ui:options': {
              baseInputStyle: {
                marginBottom: 0,
                ...(baseInputStyle ?? {}),
              },
            },
          },
        },
      })
      return combinedSchema
    }, metadata)
  }

  if (connectedServiceAttestation) {
    return extendMetadata(extendedMetadata, {
      schema: {
        properties: {
          connectedServiceAttestation: {
            name: 'connectedServiceAttestation',
            title: connectedServiceAttestation.attestationText,
            type: 'boolean',
            ...(checkboxProps && { widgetProps: checkboxProps }),
          },
        },
      },
      uiSchema: {
        'ui:order': ['connectedServiceAttestation'],
        connectedServiceAttestation: {
          'ui:widget': 'checkbox',
          'ui:options': {
            baseInputStyle: {
              marginBottom: 0,
              ...(baseInputStyle ?? {}),
            },
          },
        },
      },
    })
  }

  return extendedMetadata
}
